import { t as globalT } from "@lingui/core/macro";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/developer-tools/graphql")({
  head: () => ({
    meta: [
      {
        title:
          globalT`Sweco REALity` +
          " - " +
          globalT`Developer Tools` +
          " - GraphQL",
      },
    ],
  }),
});
